<template>
  <my-modal v-model:visible="visible" title="Тэмдэглэл бүртгэх" @save="handleSave" :saving="saving">
    <my-input label="Асуудалтай эсэх" type="checkbox" v-model="isProblem"></my-input>
    <my-input label="Уусан эсэх" type="checkbox" v-model="isDrunk"></my-input>
    <my-input label="Тайлбар" type="textarea" v-model="note" :error="errors.includes('note')"></my-input>
  </my-modal>
</template>
<script>
export default {
  props: {
    contractId: { type: Number },
    customerNote: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      saving: false,
      id: null,
      isProblem: false,
      isDrunk: false,
      note: '',
      errors: []
    }
  },
  computed: {
    visible: {
      get () {
        return !!this.contractId
      },
      set (val) {
        if (!val) {
          this.$emit('update:contractId', null)
        }
      }
    }
  },
  watch: {
    contractId (val) {
      if (val) {
        this.id = null
        this.isProblem = false
        this.isDrunk = false
        this.note = ''
        if (this.customerNote && 'isProblem' in this.customerNote) {
          this.isProblem = this.customerNote.isProblem
        }
        if (this.customerNote && 'isDrunk' in this.customerNote) {
          this.isDrunk = this.customerNote.isDrunk
        }
      }
    }
  },
  methods: {
    async handleSave () {
      try {
        if (this.saving) {
          return
        }
        this.errors = []
        if (!this.note || this.note.trim() === '') {
          this.errors.push('note')
          return
        }
        this.saving = true
        const data = (await this.axios.post('contracts/customerNote', {
          contract: this.contractId,
          id: this.id,
          isProblem: this.isProblem,
          isDrunk: this.isDrunk,
          note: this.note
        })).data
        this.id = data.id
        this.$emit('saveCustomerNote', data)
        this.visible = false
        this.showToast('Амжилттай хадгаллаа.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
